module.exports = __webpack_public_path__ + "static/img/ewm.2796cba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ewm.jpg
// module id = LnXS
// module chunks = 1